// Languages a user can ask the bot to reply in. The value is sent to the chat
// API as `language` (the natural English name). The server resolves it against
// its own allowlist (ChatService.SupportedLanguages) before use, so this list
// must stay in sync with that set — any value not on the server allowlist is
// ignored. An empty value ("") means "no override" — the bot answers in
// whatever language the user writes in.
export interface ChatLanguage {
  value: string;
  label: string;
}

// Helper copy shown alongside the reply-language picker (accessibility hint).
export const AUTO_LANGUAGE_HELP = "Auto replies in the language used in your question.";

export const CHAT_LANGUAGES: ChatLanguage[] = [
  { value: "", label: "Auto – Same as my question" },
  { value: "English", label: "English" },
  { value: "Spanish", label: "Español" },
  { value: "French", label: "Français" },
  { value: "German", label: "Deutsch" },
  { value: "Italian", label: "Italiano" },
  { value: "Portuguese", label: "Português" },
  { value: "Dutch", label: "Nederlands" },
  { value: "Russian", label: "Русский" },
  { value: "Arabic", label: "العربية" },
  { value: "Hindi", label: "हिन्दी" },
  { value: "Chinese (Simplified)", label: "简体中文" },
  { value: "Japanese", label: "日本語" },
  { value: "Korean", label: "한국어" },
  { value: "Urdu", label: "اردو" },
  // Roman Urdu = Urdu written in Latin/Roman script (e.g. "theek hai", "mje btao").
  // Kept separate from "Urdu" (Nastaliq/Arabic script) so the language directive
  // can explicitly enforce Latin-script responses.
  { value: "Roman Urdu", label: "Roman Urdu (رومن اردو)" },
];
